export const vi = {
    // Sidebar menu
    home: 'Trang Chủ',
    learningCorner: 'Góc Học Tập',
    fullMockTests: 'Lộ Trình / Thi Thử',
    skillPractice: 'Luyện Kỹ Năng',
    skillMap: 'Bản Đồ Năng Lực',
    recentActivity: 'Lịch Sử Làm Bài',
    library: 'Thư Viện',
    report: 'Báo Cáo Tuần',
    settings: 'Cài Đặt',
    logout: 'Đăng Xuất',

    // Dashboard
    choosePath: 'Lộ trình học',
    learningCornerTitle: 'Góc Học Tập',
    learningCornerDesc: 'Xây dựng vốn từ vựng và ngữ pháp Flyers qua các bài tập chủ đề, danh sách từ theo chủ đề và luyện tập tương tác.',
    learningCornerCta: 'Học ngay',
    skillPracticeTitle: 'Luyện Kỹ Năng',
    skillPracticeDesc: 'Nâng cao kỹ năng Nghe, Đọc-Viết và Nói với các bộ bài tập chuyên sâu, bám sát cấu trúc đề thi Flyers thật.',
    skillPracticeCta: 'Bắt đầu',
    fullMockTestTitle: 'Đề Thi Thử',
    fullMockTestDesc: 'Làm bài thi thử đầy đủ đúng định dạng Flyers — có tính giờ, cấu trúc chuẩn và chấm điểm như kỳ thi thật.',
    fullMockTestCta: 'Thi ngay',
    welcome: 'Xin chào',
    today: 'Hôm nay',
    level: 'Trình độ',
    streak: 'Chuỗi',
    stars: 'Sao',
    shields: 'Khiên',
    days: 'ngày',
    dailyQuests: 'Nhiệm vụ hôm nay',
    quickPractice: 'Luyện tập nhanh',
    quickPracticeDesc: 'AI chọn bài phù hợp • 5-10 phút',
    quickPracticeCta: '1 click → vào quiz ngay! ⚡',
    start: 'Bắt đầu',
    fullMockExam: 'Thi thử Full đề',
    fullMockExamDesc: 'Mô phỏng đề thi thật • 45 phút',
    fullMockExamCta: 'Trải nghiệm phòng thi thật 🏆',
    selectExam: 'Chọn đề thi',
    overallProgress: 'Tiến độ tổng quan',
    viewLibrary: 'Xem Thư Viện',
    noData: 'Chưa có dữ liệu học tập',
    doExercises: 'Hãy làm bài để theo dõi tiến độ!',
    weaknesses: 'Điểm yếu cần cải thiện',
    noWeaknesses: 'Tốt lắm! Chưa phát hiện điểm yếu',
    keepGoing: 'Tiếp tục làm bài để nhận phân tích chi tiết hơn',
    trained: 'Đã luyện',
    times: 'lần',
    train: 'Luyện',
    suggestions: 'Gợi ý cho con hôm nay',
    noSuggestions: 'Chưa có gợi ý cá nhân hoá',
    doMore: 'Hãy làm thêm bài để AI phân tích!',
    recentActivityTitle: 'Hoạt động gần đây',
    viewAll: 'Xem tất cả',

    // Settings
    settingsTitle: 'Cài Đặt',
    accountSection: 'Tài Khoản',
    generalSection: 'Cài Đặt Chung',
    levelLabel: 'Trình độ',
    languageLabel: 'Ngôn Ngữ',
    languageSub: 'Chọn ngôn ngữ hiển thị',
    logoutSub: 'Thoát khỏi tài khoản hiện tại',
    confirmLogoutTitle: 'Đăng xuất?',
    confirmLogoutMsg: 'Bạn có chắc muốn đăng xuất không?',
    cancel: 'Huỷ',
    version: 'Phiên bản',
    verified: 'Đã xác thực',
    user: 'Người dùng',

    // Full Test Attempt
    exit: 'Thoát',
    part: 'Phần',
    question: 'Câu',
    hint: 'Gợi ý',
    showHint: 'Hiện gợi ý',
    hideHint: 'Ẩn gợi ý',
    fillCorrectAnswer: 'Điền đáp án đúng',
    timer: 'Thời gian',
    loading: 'Đang tải...',
    gradingTitle: 'Giáo viên đang chấm bài...',
    gradingDesc: 'Vui lòng chờ trong giây lát. Hệ thống AI đang phân tích bài làm của em.',
    next: 'Tiếp',
    previous: 'Trước',
    finish: 'Hoàn thành',
    submitAndResult: 'Nộp bài & Xem kết quả 🎉',
    back: 'Quay lại',
    review: 'Xem lại',
    great: 'Tuyệt vời! 🎉',
    completedSection: 'Em đã hoàn thành phần',
    readyForNext: 'Sẵn sàng cho thử thách tiếp theo chưa? ⭐',
    importantNote: 'Lưu ý quan trọng',
    cannotGoBack: 'Sau khi chuyển sang phần tiếp theo, em không thể quay lại sửa câu trả lời của phần này.',
    finalStretch: 'Chặng đường cuối',
    completedAllSections: 'Em đã hoàn thành tất cả các phần thi! Nhấn nút bên dưới để nộp bài và xem kết quả nhé.',
    reviewMode: 'Chế độ Review',
    reviewFinished: 'Em đã xem lại xong phần này!',
    reviewModeDesc: 'Nhấn nút bên dưới để chuyển sang xem lại phần tiếp theo.',
    reviewAllFinished: 'Em đã xem lại hết toàn bộ bài thi rồi đó!',
    backToResult: 'Về trang kết quả',
    nextSection: 'Phần tiếp theo →',

    // Left Panel
    audioTrack: 'Audio Track',
    playing: 'Đang phát...',
    wordBank: 'Word Bank',
    colorPalette: 'Bảng Chọn Màu',
    fillWord: 'Điền từ',
    dragToImage: 'Kéo ô vào đúng vị trí trên hình, sau đó viết từ đúng.',
    dragBox: 'Kéo vào hình',
    typeWord: 'gõ từ...',
    answerChoices: 'Lựa chọn đáp án',
    chooseCorrectWords: 'Lựa chọn',
    noNo: 'STT',
    optionA: 'Lựa chọn A',
    optionB: 'Lựa chọn B',
    optionC: 'Lựa chọn C',
    error: 'Lỗi',

    // Language names
    langLabel: 'Tiếng Việt',
    langFlag: '🇻🇳',

    // Full Test Result
    testCompleted: 'Hoàn thành bài thi!',
    excellentResult: 'Tuyệt vời! Đây là kết quả của em.',
    overallScore: 'Điểm tổng quát',
    accuracy: 'Chính xác',
    attempted: 'Đã làm',
    skipped: 'Bỏ qua',
    sectionDetails: 'Chi tiết từng phần',
    scoreLabel: 'Điểm',
    perfectSection: 'Tuyệt vời! Điểm tuyệt đối phần này',
    reviewAttempt: 'Xem lại bài làm',
    backToHome: 'Quay về trang chủ',
};
